<template>
  <div class="complex-operator">
    <hot-spot v-if="count === 0" @btnClick="catchPlusTap" />
    <btn-config
      v-if="count === 0"
      :width="btnWidth"
      has-bg-img
      :text="text"
      :bg-start-color="bgStartColor"
      :bg-end-color="bgEndColor"
      :icon-name="useIcon ? 'jiahaobai' : ''"
      :icon-size="'16px'"
      :font-size="fontSize"
    />
    <div v-else class="visual has-count">
      <div class="sub" :style="{ width: plusMinusBtnWidth + 'rem' }">
        <hot-spot :right="0" @btnClick="catchMinusTap" />
        <maple-icon
          size="0.32rem"
          name="jianhao"
          :color="iconColor ? iconColor : THEME_COLOR"
        />
      </div>
      <div class="num" @click.stop="keyboardTap">
        {{ count }}
      </div>
      <div class="add" :style="{ width: plusMinusBtnWidth + 'rem' }">
        <hot-spot :left="0" @btnClick="catchPlusTap" />
        <maple-icon
          size="0.32rem"
          name="jiahao"
          :color="
            count < statusRemindInfo.available_amount
              ? iconColor
                ? iconColor
                : THEME_COLOR
              : '#BFBFBF'
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import HotSpot from './hotSpot'
import BtnConfig from './btnConfig'
import { NEW_ADD_CART_STEP } from '@/defines/const'
import { THEME_COLOR } from '@/defines/environment/config'
export default {
  name: 'ComplexComp',
  components: {
    BtnConfig,
    HotSpot
  },
  props: {
    statusRemindInfo: {
      type: Object,
      default: () => {}
    },
    canBuy: {
      type: Boolean,
      default: false
    },
    useIcon: {
      type: Boolean,
      default: true
    },
    count: {
      type: Number,
      default: 0
    },
    btnWidth: {
      type: Number,
      default: 0.52
    },
    text: {
      type: String,
      default: ''
    },
    addStepType: {
      type: String,
      default: 'normal'
    },
    bgStartColor: {
      type: String,
      default: ''
    },
    bgEndColor: {
      type: String,
      default: ''
    },
    iconColor: {
      type: String,
      default: ''
    },
    fontSize: {
      type: Number,
      default: 0.26 // 13px=>0.26rem
    }
  },
  data() {
    return {
      THEME_COLOR
    }
  },
  computed: {
    plusMinusBtnWidth() {
      const stepType = NEW_ADD_CART_STEP[this.addStepType]
      return stepType.plusMinusBtnWidth
    }
  },
  methods: {
    catchMinusTap() {
      this.$emit('sub')
    },
    catchPlusTap() {
      this.$emit('add')
    },
    keyboardTap() {
      this.$emit('keyboard')
    }
  }
}
</script>

<style lang="scss" scoped>
.complex-operator {
  position: relative;

  height: 0.52rem;

  @include flex-row-center;

  .visual {
    height: 0.52rem;

    background-color: #f5f5f5;

    flex: none;
    @include flex(row, flex-start, center, nowrap);

    &.has-count {
      border-radius: 0.26rem;
    }

    .sub,
    .num,
    .add {
      position: relative;

      height: 0.52rem;

      text-align: center;
      @include flex-column-center;
    }

    .num {
      width: 0.64rem;

      font-size: 0.26rem;
      font-weight: bold;
      color: #262626;
      &:after {
        display: block;

        position: absolute;
        top: -0.16rem;
        right: 0;
        bottom: -0.16rem;
        left: 0;

        content: '';
      }
    }

    .sub,
    .add {
      width: 0.48rem; // 长32px(.64rem) 正常24px(.48rem) !! 待对接
    }
  }
}
</style>
